import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core'
import { FormBuilder, FormControl, FormGroup, FormGroupDirective,  Validators } from '@angular/forms'

@Component({
    selector: 'app-form-input-text',
    templateUrl: 'form-input-text.html'
})
export class FormInputTextComponent implements OnInit, OnChanges {

    @Input() label: string
    @Input() value: string | undefined = ''
    @Input() placeholderText = 'Enter your full name'
    @Input() fieldId = 'text'
    @Input() darkTheme = false
    @Input() minLength = 2
    @Input() required = true
    @Input() fieldsetModifierClassnames: string
    @Input() inputModifierClassnames: string
    @Input() useMinWidth = false
    @Input() punctuationAndSpecialCharactersAllowed = false
    @Input() numbersAllowed = false
    @Input() numbersOnly = false

    form: FormGroup
    textRegx: RegExp

    constructor(
        private rootFormGroup: FormGroupDirective,
        private formBuilder: FormBuilder) {}

    ngOnInit(): void {
        this.form = this.rootFormGroup.control

        // Allow only text and space OR text, space and punctuation (. , ! ?)
        this.textRegx = this.punctuationAndSpecialCharactersAllowed
            ? /^[\p{L}\p{M}\s'"`.,!?_@/%#&+-]*$/u
            : /^[\p{L}\p{M}\s'"`]*$/u

        // Append regex to also allow numbers if numbersAllowed is true
        if (this.numbersAllowed) {
            this.textRegx = this.punctuationAndSpecialCharactersAllowed
                ? /^[\p{L}\p{M}\p{N}\s'"`.,!?_@/%#&+-]*$/u
                : /^[\p{L}\p{M}\p{N}\s'"`]*$/u
        }

        const validators = this.getValidators()

          this.form.addControl(
                this.fieldId,
                new FormControl(this.value, validators)
            )

        this.form.addControl(
            this.fieldId,
            new FormControl(this.value, validators)
        )
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.required?.isFirstChange()) { return }
        if (changes?.required?.previousValue !== changes?.required?.currentValue) {
            if (changes.required.currentValue) {
                this.addValidators()
            } else {
                this.removeValidators()
            }
        }
    }

    private getValidators() {
        return [
            this.required ? Validators.required : null,
            !this.numbersOnly ? Validators.pattern(this.textRegx) : null,
            !this.numbersOnly ? Validators.minLength(this.minLength) : null
        ].filter(Boolean)
    }

    private removeValidators() {
        this.form.get(this.fieldId)?.clearValidators()
        this.form.get(this.fieldId)?.updateValueAndValidity()
    }

    private addValidators() {
        this.form.get(this.fieldId)?.setValidators(this.getValidators())
        this.form.get(this.fieldId)?.updateValueAndValidity()
    }

    get control(){
        return this.form.get(this.fieldId)
    }
}
